import React from "react";
import { useQueries } from "@tanstack/react-query";
import getGlobalStats from "../../api/stats/get-global-stats";
import dayjs from "dayjs";

const metrics = {
  parking_count: { suffix: "", title: "Parkings" },
  average_parking_time: { suffix: "minutes", title: "Average parking time" },
  average_transition_time: {
    suffix: "minutes",
    title: "Average delivery time",
  },
  active_valets: { suffix: "", title: "Active Valets" },
};

export default () => {
  const queries = useQueries({
    queries: Object.keys(metrics).map((metric) => {
      return {
        queryKey: [metric],
        queryFn: getGlobalStats,
      };
    }),
  });
  const findDataWithYesterdayDate = (data) => {
    console.log(dayjs().subtract(1, "day").format("YYYY-MM-DD"));
    return data.find((d) => {
      console.log(dayjs(d.date).format("YYYY-MM-DD"));
      return (
        dayjs(d.date).format("YYYY-MM-DD") ===
        dayjs().subtract(1, "day").format("YYYY-MM-DD")
      );
    });
  };
  return (
    <div className="stats shadow w-full mb-4">
      {Object.keys(metrics).map((metric, idx) => {
        return (
          <div className="stat place-items-center">
            <div className="stat-title">{metrics[metric].title}</div>
            <div className="stat-value">
              {queries[idx].isLoading ? (
                <span className="loading loading-dots loading-lg"></span>
              ) : queries[idx].data ? (
                `${parseInt(
                  findDataWithYesterdayDate(queries[idx].data)?.value
                )} ${metrics[metric].suffix}`
              ) : (
                "-"
              )}
            </div>
            <div className="stat-desc">Yesterday</div>
          </div>
        );
      })}
    </div>
  );
};
